import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { Navbar } from '../Navbar/Navbar'
import { Footer } from '../Footer/Footer'
import { CookieConsent } from '../../components/ui-blocks/CookieConsent'
import { useAuthContext } from '../../AuthContext'

// Public routes that must remain reachable when signed in (auth/utility flows).
// /login is intentionally NOT here — signed-in users go to /dashboard;
// logout happens via the sidebar. /unsubscribe is here so a staff member
// clicking the link in a test send isn't bounced to the dashboard.
const ALLOWED_WHEN_AUTHED = new Set<string>(['/reset-password', '/unsubscribe'])

export const ADMIN_HOME = '/dashboard'

export const PublicLayout = () => {
  const { user, isSignInLoading } = useAuthContext()
  const { pathname } = useLocation()

  // Once auth has resolved, signed-in users are bounced to the dashboard —
  // the marketing site is for unauthenticated visitors only.
  if (!isSignInLoading && user && !ALLOWED_WHEN_AUTHED.has(pathname)) {
    return <Navigate to={ADMIN_HOME} replace />
  }

  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
      <CookieConsent />
    </>
  )
}
